import { useMemo } from "react";
import type RenderableDeselectedConstructionElement from "../../../../types/RenderableDeselectedConstructionElement";
import type DeselectedElementsPanelNewProps from "./DeselectedElementsPanelNewProps";
import styles from "./deselectedElementsPanelNew.module.scss";
import { Stack } from "@fluentui/react";
import IsaacList from "../../../../components/isaacList/IsaacList";

//  TODO: rework
const DeselectedElementsPanelNew: React.FunctionComponent<DeselectedElementsPanelNewProps> = ({
    construction,
    calculationResults
}) => {
    const items = useMemo<RenderableDeselectedConstructionElement[]>(() => {
        if (construction === undefined) {
          return [];
        }
  
        return (calculationResults?.deselectedConstructionElements ?? []).map(d => ({
          compartment: d.compartment,
          entityType: d.entityType,
          position: d.position,
        }));
      }, [calculationResults, construction]);
    
    return (
        <Stack grow={1} className={styles.container}>
          {items.length > 0 && (
            <>
              {/* TODO: Move all text into translation files */}
              <h3 className={styles.header}>Deselected construction elements</h3>
              <IsaacList<RenderableDeselectedConstructionElement>
                items={items}
                onRenderCell={item => (
                  <>
                    {item?.compartment !== undefined && item?.position !== undefined
                      ? `${item?.entityType}(${item?.compartment},${item?.position})`
                      : item?.compartment !== undefined
                        ? `${item?.entityType}(${item?.compartment})`
                        : item?.entityType}
                  </>
                )}
              />
            </>
          )}
        </Stack>
      );
};

export default DeselectedElementsPanelNew;